import React, { useState, useRef } from 'react'
import { ChevronDown, ChevronRight } from 'react-bootstrap-icons'

import {
  Container,
  WrapHeader,
  TitleContainer,
  Title,
  Flag,
  OptionThumbnail,
  CollapseButton,
  CollapsibleContent
} from './styles'

import { ProductOption as ProductOptionController, useLanguage } from '~components'
import { Alert } from '~ui'

const ProductOptionUI = (props) => {
  const { children, option } = props
  const containerRef = useRef(null)

  const [, t] = useLanguage()
  const [incrementPriceAlert, setIncrementPriceAlert] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(!(option?.min > 0))

  const hideProductOptionImage = true

  let maxMin = `${t('MIN', 'Min')}. ${option.min} - ${t('MAX', 'Max')}. ${option.max}`
  if (option.min === 1 && option.max === 1) {
    maxMin = t('REQUIRED', 'Required')
  } else if (option.min === 0 && option.max > 0) {
    maxMin = `${t('MAX', 'Max')}. ${option.max}`
  } else if (option.min > 0 && option.max === 0) {
    maxMin = `${t('MIN', 'Min')}. ${option.min})`
  }

  const handleToggleCollapse = () => {
    const newCollapsedState = !isCollapsed
    setIsCollapsed(newCollapsedState)

    if (!newCollapsedState) {
      setTimeout(() => {
        const element = document.getElementById(`id_${option?.id}`)
        const modalContainer = document.querySelector('.popup-dialog, .modal-dialog')
        if (element && modalContainer) {
          const yOffset = -75
          const elementTop = element.getBoundingClientRect().top
          const modalTop = modalContainer.getBoundingClientRect().top
          const scrollTop = elementTop - modalTop + yOffset

          modalContainer.scrollTo({
            top: modalContainer.scrollTop + scrollTop,
            behavior: 'smooth'
          })
        }
      }, 100)
    }
  }

  return (
    <>
      <Container id={`id_${option?.id}`} ref={containerRef}>
        <WrapHeader onClick={handleToggleCollapse}>
          <TitleContainer>
            {!hideProductOptionImage && option.image && option.image !== '-' && (
              <OptionThumbnail src={option.image} />
            )}
            <div className='title-container'>
              <Title><span>{option.name}</span></Title>
              <Flag required={option?.min > 0}>{maxMin}</Flag>
            </div>
          </TitleContainer>
          <CollapseButton>
            {isCollapsed ? <ChevronRight /> : <ChevronDown />}
          </CollapseButton>
        </WrapHeader>
        <CollapsibleContent isCollapsed={isCollapsed}>
          {children}
        </CollapsibleContent>
      </Container>
      <Alert
        title={t('PRODUCT_FORM', 'Product form')}
        content={`${t('OPTIONS_PRICE_INCREMENT', 'The price of the product will increase because additional options have been selected')}`}
        open={incrementPriceAlert}
        acceptText={t('ACCEPT', 'Accept')}
        onClose={() => setIncrementPriceAlert(false)}
        onAccept={() => setIncrementPriceAlert(false)}
        closeOnBackdrop={false}
      />
    </>
  )
}

export const ProductOption = (props) => {
  const productOptionProps = {
    ...props,
    UIComponent: ProductOptionUI
  }

  return (
    <ProductOptionController {...productOptionProps} />
  )
}
